// Modal stack hook — supports nested modal navigation
import { useState, useCallback } from 'react';

export function useModalStack() {
  const [stack, setStack] = useState([]);

  const push = useCallback((modal) => setStack((s) => [...s, modal]), []);
  const pop = useCallback(() => setStack((s) => s.slice(0, -1)), []);
  const clear = useCallback(() => setStack([]), []);

  const top = stack[stack.length - 1] || null;

  return { stack, top, push, pop, clear };
}
